var _style, _g, _g2, _g3, _g4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIqonTest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{opacity:0.15;}\n\t.st2{clip-path:url(#SVGID_2_);}\n\t.st3{fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st4{opacity:0.4;}\n\t.st5{clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st6{clip-path:url(#SVGID_4_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "test_1_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,16.7c-0.6-0.7-0.9-1.6-0.9-2.6c0-2.4,1.9-4.3,4.3-4.3c0.7,0,1.3,0.2,1.8,0.4V4c0-1.1-0.9-2-2-2H6C4.9,2,4,2.9,4,4 v16c0,1.1,0.9,2,2,2h4.7c-0.1-0.1-0.1-0.2-0.2-0.4c-0.5-1.2-0.2-2.6,0.8-3.5C12,17.5,12.7,17.1,13.5,16.7z M6,5.5h10v1H6V5.5z  M6,8.5h8v1H6V8.5z M6,11.5h6v1H6V11.5z M6,15.5v-1h6v1H6z M21.5,19.2c-1.2-1.1-2.8-1.7-4.6-1.7s-3.4,0.7-4.6,1.7 c-1.1,1-0.3,2.9,1.2,2.7c0.2,0,0.4-0.1,0.5-0.1c0.9-0.4,1.8-0.6,2.9-0.6s2,0.2,2.9,0.6c0.2,0.1,0.3,0.1,0.5,0.1 C21.8,22.1,22.6,20.3,21.5,19.2z M14.1,14.1c0,1.6,1.3,2.8,2.8,2.8c1.6,0,2.8-1.3,2.8-2.8c0-1.6-1.3-2.8-2.8-2.8 C15.3,11.3,14.1,12.6,14.1,14.1z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "border"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "grid"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "keylines"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIqonTest);
export default __webpack_public_path__ + "static/media/iqon_test.24c47f3b.svg";
export { ForwardRef as ReactComponent };